class MegaMenuTabber extends HTMLElement {
  connectedCallback() {
    this.links = this.querySelectorAll('.mega-menu__sidebar-link');
    this.panels = this.querySelectorAll('.mega-menu__panel');

    this.links.forEach((link) => {
      // Switch level 3 panel on hover
      link.addEventListener('mouseenter', () => this.activateTab(link));
      // Switch level 3 panel on keyboard focus
      link.addEventListener('focus', () => this.activateTab(link));
    });
  }

  activateTab(selectedLink) {
    const targetId = selectedLink.getAttribute('data-target');

    // Deactivate all links
    this.links.forEach((l) => l.classList.remove('is-active'));
    
    // Hide all panels
    this.panels.forEach((panel) => {
      panel.classList.remove('is-active');
      panel.hidden = true;
    });

    // Activate hovered link
    selectedLink.classList.add('is-active');

    // Show target level 3 panel
    const targetPanel = this.querySelector(`#${targetId}`);
    if (targetPanel) {
      targetPanel.classList.add('is-active');
      targetPanel.hidden = false;
    }
  }
}

if (!customElements.get('mega-menu-tabber')) {
  customElements.define('mega-menu-tabber', MegaMenuTabber);
}